import projectFloridaImg from 'images/projects/new/Florida.webp';
import projectPacificNorthWestImg from 'images/projects/new/PacificNorthWest.webp';
import projectMidwestImg from 'images/projects/new/Midwest.webp';
import projectDeployment1Img from 'images/projects/new/Deployment1.webp';
import projectDeployment2Img from 'images/projects/new/Deployment2.webp';
import projectDeployment3Img from 'images/projects/new/Deployment3.webp';
import projectEnergy1Img from 'images/projects/new/Energy1.webp';
import projectEnergy2Img from 'images/projects/new/Energy2.webp';
import projectEnergy3Img from 'images/projects/new/Energy3.webp';
import projectEnergy4Img from 'images/projects/new/Energy4.webp';
import projectEnergy5Img from 'images/projects/new/Energy5.webp';
import projectEnergy6Img from 'images/projects/new/Energy6.webp';
import projectEngineering1Img from 'images/projects/new/Engineering1.webp';
import projectEngineering2Img from 'images/projects/new/Engineering2.webp';
import projectEngineering3Img from 'images/projects/new/Engineering3.webp';
import projectOhioImg from 'images/projects/new/Ohio.webp';
import projectOregonImg from 'images/projects/new/Oregon.webp';
import projectWashingtonImg from 'images/projects/new/Washington.webp';
import projectKentuckyWaterImg from 'images/projects/new/KentuckyWater.webp';
import projectMontanaWaterImg from 'images/projects/new/MontanaWater.webp';

export const projectFlorida = (projectFloridaImg as any).src || projectFloridaImg;
export const projectPacificNorthWest = (projectPacificNorthWestImg as any).src || projectPacificNorthWestImg;
export const projectMidwest = (projectMidwestImg as any).src || projectMidwestImg;
export const projectDeployment1 = (projectDeployment1Img as any).src || projectDeployment1Img;
export const projectDeployment2 = (projectDeployment2Img as any).src || projectDeployment2Img;
export const projectDeployment3 = (projectDeployment3Img as any).src || projectDeployment3Img;
export const projectEnergy1 = (projectEnergy1Img as any).src || projectEnergy1Img;
export const projectEnergy2 = (projectEnergy2Img as any).src || projectEnergy2Img;
export const projectEnergy3 = (projectEnergy3Img as any).src || projectEnergy3Img;
export const projectEnergy4 = (projectEnergy4Img as any).src || projectEnergy4Img;
export const projectEnergy5 = (projectEnergy5Img as any).src || projectEnergy5Img;
export const projectEnergy6 = (projectEnergy6Img as any).src || projectEnergy6Img;
export const projectEngineering1 = (projectEngineering1Img as any).src || projectEngineering1Img;
export const projectEngineering2 = (projectEngineering2Img as any).src || projectEngineering2Img;
export const projectEngineering3 = (projectEngineering3Img as any).src || projectEngineering3Img;
export const projectOhio = (projectOhioImg as any).src || projectOhioImg;
export const projectOregon = (projectOregonImg as any).src || projectOregonImg;
export const projectWashington = (projectWashingtonImg as any).src || projectWashingtonImg;
export const projectKentuckyWater = (projectKentuckyWaterImg as any).src || projectKentuckyWaterImg;
export const projectMontanaWater = (projectMontanaWaterImg as any).src || projectMontanaWaterImg;